import "isomorphic-unfetch";

export default class http {

  static _initializeHeaders(headers) {
    if (headers) {
      return headers;
    }

    return {
      "Content-Type": "application/json",
    };
  }

  static _getCombinedParams(params, includeGlobalParams = true) {
    if (!includeGlobalParams) {
      return params;
    }
    
    if (params instanceof FormData) {
      if (http.params) {
        Object.keys(http.params).forEach(key => params.append(key, http.params[key]));
      }

      return params;
    }

    return {
      ...(params != null && params),
      ...(http.params != null && http.params),
    };
  }

  /**
   * 
   * @param {Object} params Array of Objects
   * @param {boolean} clear 
   */
  static attach(params = {}, clear = true) {
    let newParams = {};

    if (params && Object.keys(params).length) {
      // Checking if params has correct format and values
      newParams = {
        ...params
      };
    }

    if (!clear && http.params) {
      http.params = { ...http.params, ...newParams };
    } else {
      http.params = newParams;
    }
  }

  static get(url, params, headers, options, includeGlobalParams = true,) {

    let combinedParams = http._getCombinedParams(params, includeGlobalParams);

    if (Object.keys(combinedParams).length) {
      let queries = [];
      Object.entries(combinedParams).forEach(([key, value]) => {
        const values = Array.isArray(value) ? value : [value];
        values.forEach(arrayValue => queries.push(`${key}=${arrayValue}`));
      });
      queries = queries.join("&");

      if (url.includes("?")) {
        url = `${url}&${queries}`;
      } else {
        url = `${url}?${queries}`;
      }
    }
    return http.send('GET', url, null, headers, options);
  }

  static post(url, params, headers, options, includeGlobalParams = true,) {
    let combinedParams = http._getCombinedParams(params, includeGlobalParams);
    return http.send('POST', url, combinedParams, headers, options);
  }

  static put(url, params, headers, options, includeGlobalParams = true,) {
    let combinedParams = http._getCombinedParams(params, includeGlobalParams);
    return http.send('PUT', url, combinedParams, headers, options);
  }

  static delete(url, params, headers, options, includeGlobalParams = true,) {
    let combinedParams = http._getCombinedParams(params, includeGlobalParams);
    return http.send('DELETE', url, combinedParams, headers, options);
  }

  /**
   * Send POST Ajax call and returns a promise to be resolved
   * @param {string} url     A string that represents where to send the request to
   * @param {object} params  params in the body with the ajax call
   * @param {object} headers headers object
   */
  static send(method, url, params, headers, options) {
    if (!url) {
      console.error(`http ${method} ${url} is not set`);
      return;
    }

    headers = http._initializeHeaders(headers);

    let body = null;
    if (params instanceof FormData) {
      body = params;
      delete headers["Content-Type"];
    } else if (params) {
      body = JSON.stringify(params);
    }

    return fetch(url, Object.assign({
        method: method,
        headers: headers,
        credentials: 'include',
        body: body
      }, options || {}))
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          throw response;
        }
      })
      .then(text => {
        // Here we are assuming that the response type will be the same as the request type.
        if (text && headers && headers.hasOwnProperty('Content-Type') && headers['Content-Type'] === 'application/json') {
          try {
            return JSON.parse(text);
          } catch (e) {
            console.error(text);
            throw e;
          }
        }

        return text;
      })
      .catch(error => {
        throw error;
      });
  }
}